import React from 'react';

import { useSelector } from 'react-redux';

import Image from '../Image';

import { Container } from './styles';

const DividerLogo = () => {
  const { seller, siteId } = useSelector(({ app }) => ({
    seller: app.getIn(['config', 'seller']),
    siteId: app.getIn(['config', 'siteId']),
  }));

  return (
    <Container>
      <Image
        defaultSize={`https://cdn.smartbr.com/${siteId}/favicon-32x32.png`}
        usePicture={false}
        lazyLoad={false}
        title={seller}
        alt={seller}
      />
    </Container>
  );
};

export default DividerLogo;
